import { inject, Injectable } from '@angular/core';
import { Navigation, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService {
  private router = inject(Router);

  public history: string[] = [];

  constructor() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart || event instanceof NavigationEnd))
      .subscribe(event => {
        // --- 1) Handle direction (back/forward) on NavigationStart ---
        if (event instanceof NavigationStart) {
          const navStart = event as NavigationStart & {
            navigationTrigger?: 'imperative' | 'popstate' | 'hashchange';
          };

          if (navStart.navigationTrigger === 'popstate') {
            // Browser back/forward: remove current entry
            this.history.pop();
          }

          return; // done for NavigationStart
        }

        // --- 2) Handle stack update on NavigationEnd ---
        if (event instanceof NavigationEnd) {
          const url = event.urlAfterRedirects;

          // Get info about the *current* navigation (if any)
          const currentNav: Navigation | null = this.router.currentNavigation();

          const isImperative = currentNav?.trigger === 'imperative';
          const replace = isImperative && !!currentNav?.extras && currentNav.extras.replaceUrl === true;

          if (!this.history.length) {
            // First entry, just push
            this.history.push(url);
            return;
          }

          if (replace) {
            // router.navigate(..., { replaceUrl: true })
            // -> mimic browser: replace top history entry
            this.history[this.history.length - 1] = url;
          } else {
            // Normal case:
            // - imperative navigate (no replaceUrl)
            // - popstate (we already popped in NavigationStart)
            // Avoid duplicate pushes
            if (this.history[this.history.length - 1] !== url) {
              this.history.push(url);
            }
          }
        }
      });
  }
}
